import { useAppTheme } from './ThemeContext';
import DriverThumbnail from '../assets/images/driver-thumbnail.png';
import DriverThumbnailLight from '../assets/images/driver-thumbnail-light.svg';
// light theme
function useDriverThumbnail(): string {
  const { themeMode } = useAppTheme();

  return themeMode === 'light' ? DriverThumbnailLight : DriverThumbnail;
}

export default useDriverThumbnail;
